import { useNavigate } from "react-router-dom"
import { routePath } from "../../../router/types"
import { ProjectTabKeys } from "../../../types/project"

function useNavigateToProjectData() {
  const navigate = useNavigate()

  return (projectId: string) => {
    navigate(`${routePath.PROJECT_DATA}?projectId=${projectId}&tab=${ProjectTabKeys.ASINS}`)
  }
}

export default useNavigateToProjectData
